import { useState, useEffect, useRef } from 'react';

export const useVersionCheck = (interval = 5 * 60 * 1000) => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const initialVersion = useRef<string | null>(null);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch('/version.json?t=' + Date.now());
        const data = await res.json();

        if (initialVersion.current === null) {
          initialVersion.current = data.version;
        } else if (data.version !== initialVersion.current) {
          setUpdateAvailable(true);
        }
      } catch (e) {
        // Silently fail - don't break app if version check fails
      }
    };

    checkVersion();
    const timer = setInterval(checkVersion, interval);
    return () => clearInterval(timer);
  }, [interval]);

  const refresh = () => window.location.reload();
  const dismiss = () => setUpdateAvailable(false);

  return { updateAvailable, refresh, dismiss };
};
